
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LoadingIndicator extends Vue {
    @Prop({ default: 'Cargando...' }) loadingText!: string;
    @Prop({ default: 'primary' }) color!: string;
    @Prop({ default: 50 }) size!: number;
    @Prop({ default: 5 }) strokeWidth!: number;
    @Prop({ default: 24 }) textSize!: number; // tamaño del texto
}
